const Component = () => import('./Confirmation');

export { Component };
